__turbopack_context__.v({
  "cardContainer": "PhotoGrid-module-scss-module__xPzHMa__cardContainer",
  "copy": "PhotoGrid-module-scss-module__xPzHMa__copy",
  "copyIndentCenter": "PhotoGrid-module-scss-module__xPzHMa__copyIndentCenter",
  "copyIndentLeft": "PhotoGrid-module-scss-module__xPzHMa__copyIndentLeft",
  "copyIndentRight": "PhotoGrid-module-scss-module__xPzHMa__copyIndentRight",
  "copyLeft": "PhotoGrid-module-scss-module__xPzHMa__copyLeft",
  "copyText": "PhotoGrid-module-scss-module__xPzHMa__copyText",
  "imageContainer": "PhotoGrid-module-scss-module__xPzHMa__imageContainer",
  "masonryGrid": "PhotoGrid-module-scss-module__xPzHMa__masonryGrid",
  "masonryGridColumn": "PhotoGrid-module-scss-module__xPzHMa__masonryGridColumn",
  "photoGridContainer": "PhotoGrid-module-scss-module__xPzHMa__photoGridContainer",
  "positionLeft": "PhotoGrid-module-scss-module__xPzHMa__positionLeft",
  "positionRight": "PhotoGrid-module-scss-module__xPzHMa__positionRight",
});
